import type { Sector } from "~/modules/sector/models/Sector.interface";

export function getSectorDepth(
  sectors: Sector[],
  targetCode: number,
  currentDepth: number = 0,
): number {
  for (const sector of sectors) {
    if (sector.code === targetCode) return currentDepth;
    if (sector.children?.length > 0) {
      const found = getSectorDepth(
        sector.children,
        targetCode,
        currentDepth + 1,
      );
      if (found !== -1) return found;
    }
  }
  return -1;
}
